<template>
  <v-btn
    v-if="!$store.getters.isDesktop"
    flat
    class="side-menu-btn ma-0"
    @click="
      () => {
        this.$store.commit('toggleMenu');
      }
    "
    icon="mdi-menu"
  ></v-btn>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      getIsMobile: "isMobile",
      getIsTablet: "isTablet",
    }),
  },
};
</script>

<style lang="scss">
.side-menu-btn {
  .v-icon {
    color: $iconColor !important;
    font-size: 30px !important;
  }
}
</style>
